<template>
  <div class="fixed inset-0 z-50">
    <file-detail-manager :file-id="route.params.file_id" :file-context="fileContext" />
  </div>
</template>

<script setup>
  definePageMeta({
    isLightbox: true
  });

  const route = useRoute();
  const {container_id_or_slug: contextId, share_token: shareToken, user_id_or_slug: userId} = route.params;

  const fileContext = {
    contextType: FILE_CONTEXTS.container,
    contextId,
    shareToken,
    userId,
    query: route.query
  };

</script>
